import Grid from '@mui/material/Grid';
import Link from '@mui/material/Link';

import type { FunctionComponent, PropsWithChildren } from 'react';

export const TableCellLinkWrapper: FunctionComponent<PropsWithChildren<{ readonly to: string }>> = ({
    children,
    to,
}) => {
    return (
        <Grid
            alignItems="center"
            container={true}
            sx={{
                position: 'relative',
            }}
            onClick={(event) => {
                event.stopPropagation();
            }}
        >
            <Link
                href={to}
                style={{
                    color: 'inherit',
                    textDecoration: 'none',
                }}
            >
                <span
                    style={{
                        height: '100%',
                        left: 0,
                        position: 'absolute',
                        top: 0,
                        width: '100%',
                        zIndex: 1,
                    }}
                />
                {children}
            </Link>
        </Grid>
    );
};
